import { styled } from "lib/theme";
import { useRouter } from "next/router";
import { RouterOutputs, trpc } from "utils/trpc";

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  font-family: ${({ theme }) => theme.app.fontFamily};
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.app.colors.secondaryText};
  margin-top: 50px;
  padding: 5px 0 50px 0;

  a {
    color: ${({ theme }) => theme.app.colors.secondaryText};
    transition: 0.14159s;
    :hover {
      color: ${({ theme }) => theme.app.colors.primary};
    }
  }
`;

type Consumer = RouterOutputs["consumers"]["me"];

export function LoggedInConsumerLabel(props: { consumer: Consumer }) {
  const utils = trpc.useContext();
  const router = useRouter();

  const logout = async () => {
    await utils.projectAuth.logout.fetch();
    router.replace("/");
  };

  return (
    <Wrapper>
      Logged in as {`${props.consumer.email}`} &nbsp;{" "}
      <a href="#" onClick={() => logout()}>
        Log out
      </a>
    </Wrapper>
  );
}
